import React, { useState } from 'react'
import { Routes, Route, NavLink, useNavigate } from 'react-router-dom'
import { AuthProvider, useAuth } from '../context/AuthContext'
import ProtectedRoute from './ProtectedRoute'
import Header from './Header'
import Login from '../pages/Login'
import Dashboard from '../pages/Dashboard.jsx'
import Services from '../pages/Services'
import Tasks from '../pages/Tasks'
import TaskFormPage from '../pages/TaskForm'
import Users from '../pages/Users'
import Roles from '../pages/Roles'
import Clients from '../pages/Clients.jsx'
import ClientContacts from '../pages/ClientContacts'
import ClientPaymentsPage from '../pages/ClientPayments'
import Invoices from '../pages/Invoices'
import InvoiceRegister from '../pages/InvoiceRegister'
import Reports from '../pages/Reports'
import TimeLogs from '../pages/TimeLogs'
import Settings from '../pages/Settings'
import ForgotPassword from '../pages/ForgotPassword'

function Layout({ children }) {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Debug: confirm user and admin state in layout
  console.log('Layout auth:', { user, isAdmin });

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (!user) return children;

  return (
    <div className="layout">
      {/* Mobile menu button */}
      <button className="mobile-menu-btn" onClick={() => setSidebarOpen(!sidebarOpen)} aria-label="Toggle menu">☰</button>
      {/* Left Sidebar */}
      <nav className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <h2>Task Manager</h2>
        <div className="nav-links">
          <NavLink to="/" end className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} onClick={() => setSidebarOpen(false)}>Dashboard</NavLink>
          <NavLink to="/reports" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} onClick={() => setSidebarOpen(false)}>Reports</NavLink>
          <NavLink to="/clients" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} onClick={() => setSidebarOpen(false)}>Clients</NavLink>
          <NavLink to="/services" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} onClick={() => setSidebarOpen(false)}>Services</NavLink>
          <NavLink to="/tasks" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} onClick={() => setSidebarOpen(false)}>Tasks</NavLink>
          <NavLink to="/time-logs" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} onClick={() => setSidebarOpen(false)}>Time Logs</NavLink>
          <NavLink to="/settings" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} onClick={() => setSidebarOpen(false)}>Settings</NavLink>
          {isAdmin && (
            <>
              <NavLink to="/invoice-register" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} onClick={() => setSidebarOpen(false)}>Invoice Register</NavLink>
              <NavLink to="/users" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} onClick={() => setSidebarOpen(false)}>Users</NavLink>
              <NavLink to="/roles" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'} onClick={() => setSidebarOpen(false)}>Roles</NavLink>
            </>
          )}
        </div>
        <div className="sidebar-footer">
          <span>{user.email}</span>
          <button onClick={handleLogout} className="logout-button">Logout</button>
        </div>
      </nav>

      <div className={`sidebar-overlay ${sidebarOpen ? 'open' : ''}`} onClick={() => setSidebarOpen(false)} />

      {/* Main Content */}
      <div className="main-content" style={{ position: 'relative' }}>
        <Header />
        {children}
      </div>
    </div>
  );
}

function AppRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/services"
          element={
            <ProtectedRoute>
              <Services />
            </ProtectedRoute>
          }
        />
        <Route path="/tasks" element={<ProtectedRoute><Tasks /></ProtectedRoute>} />
        <Route path="/tasks/add" element={<ProtectedRoute><TaskFormPage /></ProtectedRoute>} />
        <Route path="/tasks/edit/:id" element={<ProtectedRoute><TaskFormPage /></ProtectedRoute>} />
        <Route
          path="/clients"
          element={
            <ProtectedRoute>
              <Clients />
            </ProtectedRoute>
          }
        />
        <Route
          path="/clients/:id/contacts"
          element={
            <ProtectedRoute>
              <ClientContacts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/clients/:id/payments"
          element={
            <ProtectedRoute>
              <ClientPaymentsPage />
            </ProtectedRoute>
          }
        />
        <Route path="/clients/:id/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
        <Route path="/invoice-register" element={<ProtectedRoute adminOnly><InvoiceRegister /></ProtectedRoute>} />
        <Route
          path="/users"
          element={
            <ProtectedRoute adminOnly>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/roles"
          element={
            <ProtectedRoute adminOnly>
              <Roles />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route path="/time-logs" element={<ProtectedRoute><TimeLogs /></ProtectedRoute>} />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}